
import request from '@/utils/request'
export default {
	//注册获取验证码
  code(data){
    return request({
      url: '/email/code',
      method: 'post',
      data
    })
  },
  //用户名重复检测
  reusername(data){
    return request({
      url: '/login/reusername',
      method: 'post',
      data
    })
  },
  //注册用户
  registeruser(data){
    return request({
      url: '/login/registeruser',
      method: 'post',
      data
    })
  },
  //用户登录
  loginUser(data){
    return request({
      url: '/login/loginUser',
      method: 'post',
      data
    })
  },
  //获取登录用户名
  getUsername(data){
    return request({
      url: '/login/getUsername',
      method: 'post',
      data
    })
  },
  //获取统计年鉴列表
  statisticalYearbookList(data){
    return request({
      url: '/nj/statisticalYearbookList',
      method: 'Get',
      data
    })
  },
  //获取统计年鉴列表
  statisticalYearbookListOpen(data){
    return request({
      url: '/nj/statisticalYearbookListOpen',
      method: 'Get',
      data
    })
  },
  //全库检索
  searchAll(data){
    return request({
      url: '/db/searchAll',
      method: 'post',
      data
    })
  },
   //获取热门搜索关键词
   hot(data){
    return request({
      url: '/search/hot',
      method: 'post',
      data
    })
  },
  //首页宣传语及Logo背景图片
  sloganlist(data){
    return request({
      url: '/slogan/list',
      method: 'post',
      data
    })
  },
  //获取地震数据
  earthquakeList(data){
    return request({
      url: '/rt/earthquakeList',
      method: 'post',
      data
    })
  },
   //获取洪水数据
   floodList(data){
    return request({
      url: '/rt/floodList',
      method: 'post',
      data
    })
  },
  //获取所有系列名称及介绍
  seriesAll(data){
    return request({
      url: '/db/seriesAll',
      method: 'get',
      data
    })
  },
  //获取单个系列介绍
  series(data){
    return request({
      url: '/db/series',
      method: 'post',
      data
    })
  },
  //获取系列核心指标
  seriesCoreLabel(data){
    return request({
      url: '/db/seriesCoreLabel',
      method: 'post',
      data
    })
  },
  //获取核心指标数据
  seriesCoreLabelData(data){
    return request({
      url: '/db/seriesCoreLabelData',
      method: 'post',
      data
    })
  },

  //根据系列获取目录
  seriesLabel(data){
    return request({
      url: '/db/seriesLabel',
      method: 'post',
      data
    })
  },
  //根据目录获取下级目录及指标
  label(data){
    return request({
      url: '/db/label',
      method: 'post',
      data
    })
  },
   //根据名称搜索指标
   labelSearch(data){
    return request({
      url: '/db/labelSearch',
      method: 'post',
      data
    })
  },
  //根据指标ID关联查询目录层级
  labelLink(data){
    return request({
      url: '/db/labelLink',
      method: 'post',
      data
    })
  },
  //根据指标ID查询相关地区
  labelArea(data){
    return request({
      url: '/db/labelArea',
      method: 'post',
      data
    })
  },
  //根据指标、地区、日期范围查询数据
  labelData(data){
    return request({
      url: '/db/labelData',
      method: 'post',
      data
    })
  },
  //根据指标、地区、日期范围下载数据
  labelDataDown(data){
    return request({
      url: '/db/labelDataDown',
      method: 'post',
      data
    })
  },
   //查询条件收藏
   dbcollection(data){
    return request({
      url: '/db/collection',
      method: 'post',
      data
    })
  },

   downFile(data){
    return request({
      url: '/down/file',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8;application/json',
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": 'http://gdtest.harborn.cn/GDDB'
      },
      responseType: 'blob'
    })
  },
  //获取个人信息
  info(data){
    return request({
      url: '/user/info',
      method: 'GET',
      data
    })
  },
  //修改用户信息
  upInfo(data){
    return request({
      url: '/user/upInfo',
      method: 'POST',
      data
    })
  },
  //修改用户密码
  upPass(data){
    return request({
      url: '/user/upPass',
      method: 'POST',
      data
    })
  },
   //我的收藏
   collection(data){
    return request({
      url: '/my/collection',
      method: 'POST',
      data
    })
  },
   //下载记录
   downLogs(data){
    return request({
      url: '/my/downLogs',
      method: 'POST',
      data
    })
  },
   //退出登录
   logout(data){
    return request({
      url: '/login/logout',
      method: 'POST',
      data
    })
  },
  //下载地震数据
  earthquakeDown(data){
    return request({
      url: '/rt/earthquakeDown',
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8;application/json',
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": 'http://gdtest.harborn.cn/GDDB'
      },
      // responseType: 'blob'
    })
  },
  //下载洪水数据
  floodDown(data){
    return request({
      url: '/rt/floodDown',
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8;application/json',
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": 'http://gdtest.harborn.cn/GDDB'
      },
      // responseType: 'blob'
    })
  },
  //获取台风所有年份
  typhoonYears(data){
    return request({
      url: '/rt/typhoonYears',
      method: 'POST',
      data
    })
  },
  //获取当年所有台风名称
  typhoonNames(data){
    return request({
      url: '/rt/typhoonNames',
      method: 'POST',
      data
    })
  },
  //获取当年所有台风名称
  typhoonNames(data){
    return request({
      url: '/rt/typhoonNames',
      method: 'POST',
      data
    })
  },
   //获取台风路径数据
   typhoonList(data){
    return request({
      url: '/rt/typhoonList',
      method: 'POST',
      data
    })
  },
   //下载台风数据
   typhoonDown(data){
    return request({
      url: '/rt/typhoonDown',
      method: 'POST',
      data
    })
  },
    //分页获取自然灾害情况信息
    naturalDisasterPage(data){
      return request({
        url: '/nd/naturalDisasterPage',
        method: 'POST',
        data
      })
    },
    //获取用户申请使用信息
    getUserInfo(data){
      return request({
        url: '/login/getUserInfo',
        method: 'POST',
        data
      })
    },
    //再次提交申请使用表
    reApply(data){
      return request({
        url: '/login/reApply',
        method: 'POST',
        data
      })
    },
     //申请统计年鉴资源
     apply(data){
      return request({
        url: '/nj/apply',
        method: 'POST',
        data
      })
    },
    //获取所有年鉴集合
    list(data){
      return request({
        url: '/nj/list',
        method: 'GET',
        data
      })
    },
    //分页获取年鉴申请记录
    page(data){
      return request({
        url: '/nj/page',
        method: 'POST',
        data
      })
    },
    //获取年鉴资源
    njSite(data){
      return request({
        url: '/nj/njSite',
        method: 'POST',
        data
      })
    },
  //获取年鉴资源
  policyType(data){
    return request({
      url: '/nd/policyType',
      method: 'GET',
      data
    })
  },
    //获取年鉴资源
  policyPage(data){
      return request({
        url: '/nd/policyPage',
        method: 'POST',
        data
      })
    },
    //获取年鉴资源
  planPage(data){
      return request({
        url: '/nd/planPage',
        method: 'POST',
        data
      })
    },

}



// WEBPACK FOOTER //
// ./src/api/index.js